function when (manager, currentPort, condition, arg) {
  switch (condition) {
    case 'hasRoofAngle':
      return manager.getValue('roof_has_angle') === 'yes'
    case 'hasDoor':
      return typeof manager.getValue('door') === 'string' && manager.getValue('door') !== 'none'
    case 'hasInstallation':
      return manager.getValue('installation') === 'yes'
    case 'hasMotor':
      return manager.getValue('motor') === 'yes'
    case 'between':
      let [between_val, min, max] = arg
      return between_val >= min && between_val <= max
    case 'equals':
      let [equals_val, match] = arg
      return equals_val === match
    case 'less':
      let [less_compare_val, less_base_val] = arg
      return less_compare_val < less_base_val
    case 'greater':
      let [greater_compare_val, greater_base_val] = arg
      return greater_compare_val > greater_base_val
    case 'doorAllowedSide':
      if (manager.getPortModel() == 8000 || manager.getPortHeight() < 212.6) {
        return false
      }
      if (manager.getWindowProperties() === null) {
        if (manager.getPortWidth() < 399.9) {
          return false
        }

        return true
      }
      let [door_side_type, door_side_rows, door_side_columns] = manager.getWindowProperties(true)
      return door_side_columns > 3
    case 'doorAllowedCenter':
      if (manager.getPortModel() == 8000 || manager.getPortHeight() < 212.6) {
        return false
      }
      if (manager.getWindowProperties() === null) {
        if (manager.getPortWidth() >= 400.0) {
          return false
        }
        return true
      }
      let [door_center_type, door_center_rows, door_center_columns] = manager.getWindowProperties(true)
      return door_center_columns === 1 || door_center_columns === 3
    default:
      return true
  }
}

export default when